module.exports = __webpack_public_path__ + "img/36ne.88789192.svg";